<template>
  <div class="page-quick-sidebar-chat-user-form">
      <div class="input-group">
          <input type="text" class="form-control" placeholder="Type a message here..." v-model="messageText" v-on:keyup.enter="sendMessage">
          <div class="input-group-btn">
              <button type="button" class="btn blue" @click="sendMessage"><i class="icon-paper-clip"></i></button>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
      return {
          messageText:''
      }
  },
    methods:{
      sendMessage(){
          this.$emit('messagesent', {
              message: this.messageText,
              admin:{
                  name: $(".username ").text()
              }
          });
              this.messageText = ""
      }
    }
}
</script>
